import { httpsCallable } from 'firebase/functions';
import { functions } from '../../../config/firebase-config';
import { notifyPermissionDenied } from '../handleCallableError';
import { prepareAuctionPhoto } from './prepareAuctionPhoto';

const fileToDataUrl = (file) =>
  new Promise((resolve, reject) => {
    if (typeof file === 'string') {
      // Flujos viejos ya envían data-URL.
      resolve(file);
      return;
    }
    if (!(file instanceof Blob)) {
      reject(new Error('Formato de imagen no soportado'));
      return;
    }
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = () => reject(reader.error);
    reader.readAsDataURL(file);
  });

/**
 * Subida autorizada de imágenes de subasta (DOM-AUC-008/009): el backend
 * autoriza ANTES de guardar y deriva el path (UID/unidad/subasta). Reemplaza
 * el upload directo a `images/...` de helpers/index.js.
 */
export const uploadAuctionImage = async (file, { imageType, dealershipId, operatingUnitId, auctionId = null }) => {
  try {
    const imageBase64 = await fileToDataUrl(await prepareAuctionPhoto(file));
    const fn = httpsCallable(functions, 'uploadAuctionImageV2');
    const result = await fn({
      imageBase64,
      imageType,
      ...(auctionId ? { auctionId } : {}),
      ...(operatingUnitId ? { operatingUnitId } : {}),
      ...(dealershipId ? { dealershipId } : {}),
      requestedApp: 'dealership_web',
    });
    if (result.data?.success === 'yes' && result.data?.data?.url) {
      return result.data.data.url;
    }
    console.error('Subida de imagen rechazada:', result.data?.message || result.data?.error?.message);
    throw new Error(result.data?.message || 'No se pudo subir la foto de la subasta');
  } catch (error) {
    console.error('Error subiendo imagen de subasta:', error);
    notifyPermissionDenied(error);
    throw error;
  }
};
